export const categories = [{
    name: 'Remaining',
    apiName: 'remaining'
}, {
    name: 'Untrusted',
    apiName: 'untrusted'
}, {
    name: 'NV Bell New',
    apiName: 'nv_bell_new'
}, {
    name: 'EPB Sample',
    apiName: 'on_error_price_before_sample'
}, {
    name: 'Sold',
    apiName: 'sold'
}, {
    name: 'Inconsistent',
    apiName: 'inconsistent'
}, {
    name: 'Redirected',
    apiName: 'redirected'
}, {
    name: 'SQC',
    apiName: 'sqc'
}, {
    name: 'Error Price Before',
    apiName: 'on_error_price_before'
}, {
    name: 'Trusted',
    apiName: 'trusted'
}, {
    name: 'NV Bell Other',
    apiName: 'nv_bell_other'
}, {
    name: 'Error Other',
    apiName: 'on_error_other'
}];

export const bots = [{
    name: 'ROBOT V3',
    apiName: 'robot_v3'
}, {
    name: 'Amazon',
    apiName: 'amazon'
}, {
    name: 'Google Shopping',
    apiName: 'google_shopping'
}];
